import React, {useState} from 'react';
import {Page, Text, View, Document, StyleSheet, Image, usePDF} from '@react-pdf/renderer';
import {Viewer} from "@react-pdf-viewer/core";

const styles = StyleSheet.create({
    pageBackground: {
        position: 'absolute',
        minWidth: '33%',
        display: 'block',
        width: '33%',
    },
});

// Create Document Component
/*const MyDocument = (
    <Document>
        <Page size="A4" style={{
            display: "flex",
        }}>
            <View  wrap={false}>
                <div>
                    <Image src={"label.png"} />
                    <Image src={"label.png"} style={{
                        top: "2%"
                    }}/>
                    <Image src={"colorcode_example.png"} style={{
                        position: "absolute",
                        width: "160px"
                    }}/>
                </div>
            </View>
        </Page>
    </Document>
);

const Label = () => {
    const [instance, updateInstance] = usePDF({document: MyDocument});
    if (instance.loading && !instance.url) return <div>Loading ...</div>;

    if (instance.error) return <div>Something went wrong: {instance.error}</div>;

    if (instance.blob)
        return (
            <div
                style={{
                    border: '1px solid rgba(0, 0, 0, 0.3)',
                    height: '750px',
                    marginTop: "4%"
                }}
            >
                <Viewer fileUrl={instance.url}/>
            </div>
        );
    else return <div>loading</div>
}*/

const Label = () => {
    return (
        <div style={{
            backgroundImage: "url('label.png')",
            backgroundSize: "100%",
            width: "100%",
            paddingBottom: "10%"
        }}>
            <div>
                        <span style={{
                            position: "absolute",
                            marginTop: "12%",
                            marginLeft: "55%",
                            fontSize: "24px",
                            fontWeight: "bold"
                        }}>{"Nome"}</span>
                <span style={{
                    position: "absolute",
                    marginTop: "23%",
                    marginLeft: "55%",
                    fontSize: "24px",
                    fontWeight: "bold"
                }}>{"Nome"}</span>
                <img alt={"not found"} width={"160px"} height={"160px"}
                     src={"colorcode_example.png"}
                     style={{
                         position: "absolute",
                         marginTop: "35%",
                         marginLeft: "90px"
                     }}/> <br/>
                <span style={{
                    position: "absolute",
                    marginTop: "53%",
                    marginLeft: "16%"
                }}>{"Nome"} - {"Nome"}</span>
                <span style={{
                    position: "absolute",
                    marginTop: "77%",
                    marginLeft: "55%",
                    fontSize: "24px",
                    fontWeight: "bold"
                }}>{"Nome"}</span>
                <span style={{
                    position: "absolute",
                    marginTop: "88%",
                    marginLeft: "55%",
                    fontSize: "24px",
                    fontWeight: "bold"
                }}>{"Nome"}</span>
                <img alt={"not found"} width={"160px"} height={"160px"}
                     src={"colorcode_example.png"}
                     style={{
                         marginTop: "101%",
                         marginLeft: "90px"
                     }}/> <br/>
                <span style={{
                    marginTop: "2%",
                    marginLeft: "16%"
                }}>{"Nome"} - {"Nome"}</span>
                <br/>
            </div>
        </div>
    );
}

export default Label;